import React, {Dispatch, FC, SetStateAction, useMemo} from "react";
import {OwnedProject, translateProjectStatus} from "api-client";
import {BoldText} from "components/common";
import styles from './MyOwnedProject.module.scss';
import {CustomLink} from "../../../common";
import {RouteDictionary} from "../../../../utils";
import {MetaSection, ProgressSection} from "./components";

interface Props {
  project: OwnedProject;
  setIsModalActive: Dispatch<SetStateAction<boolean>>;
  setProjectUuid: Dispatch<SetStateAction<string>>;
}

const MyOwnedProject: FC<Props> = ({project, setIsModalActive, setProjectUuid}) => {
  const progress = useMemo(() => {
    if (!project.targetSum || project.targetSum.amount <= 0) return 0;
    return Math.max(0, Math.min(100, Math.round((project.investedSum.amount / project.targetSum.amount) * 100)));
  }, [project.investedSum.amount, project.targetSum.amount]);

  const handleModalActive = () => {
    setProjectUuid(project.uuid);
    setIsModalActive(true);
  };

  return (
    <article className={styles.myOwnedProject}>
      <CustomLink
        to={RouteDictionary.BORROWER_DETAILED_PROJECT}
        params={{uuid: project.uuid}}
        className={styles.myOwnedProject__header}
      >
        <div className={styles.myOwnedProject__titleContainer}>
          <BoldText>
            <div className={styles.myOwnedProject__title}>
              {project.name[0]?.text}
            </div>
          </BoldText>

          <div
            className={`${styles.myOwnedProject__status} ${
              styles[`myOwnedProject__status--${project.status}`] ?? ""
            }`}
          >
            {translateProjectStatus(project.status)}
          </div>
        </div>

        <MetaSection project={project} />
      </CustomLink>

      <ProgressSection
        project={project}
        progress={progress}
        onShowSchedule={handleModalActive}
      />
    </article>
  );
};

export default MyOwnedProject;
